import { Palette } from "types/theme";

export const palette: Palette = {
  background: {
    base: '#151515',
    primary: '#292929',
    themeController: '#0B0A0A',
    themeControllerActive: '#383838',
    menuItemActive: '#383838',
    accent: '#6777FF',
    newReleaseCardsActive: '#F4F4F4',
  },
  text: {
    primary: '#ffffff',
    secondary: '#ffffff',
    label: '#939393',
    link: '#6777FF',
    breadcrumbs: '#7C7C7C'
  },
  divider: {
    primary: '#DADADA',
  },
  icon: {
    primary: '#FFFFFF',
    accent: '#6777FF',
  },
  border: {
    accent: '#6777FF',
    basic1: '#E9E9E9',
  },
  button: {
    primary: '#6777FF',
  },
  checkbox: {
    primary: '#6777FF',
  },
};
